var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagAlgr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13090_62975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13090_62975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4974 25.1435C13.2757 25.1435 9.85333 21.7211 9.85333 17.4995C9.85333 13.2778 13.2757 9.85543 17.4974 9.85543C17.4984 9.85543 17.4995 9.85543 17.5005 9.85543V0C7.83464 0 0 7.83464 0 17.5005C0 27.1654 7.83464 35.0011 17.5005 35.0011V25.1446C17.4995 25.1435 17.4984 25.1435 17.4974 25.1435Z",
    fill: "#006233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1992 17.5003C13.1992 20.2592 15.0062 22.5949 17.4998 23.3931V11.6074C15.0062 12.4046 13.1992 14.7413 13.1992 17.5003Z",
    fill: "#006233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6687 18.3596L24.2381 17.5203L21.6655 16.6895L21.6613 13.9863L20.0765 16.1756L17.5039 15.3448L19.0961 17.5288L17.5113 19.718L20.0807 18.8788L21.6729 21.0628L21.6687 18.3596Z",
    fill: "url(#paint0_linear_13090_62975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3837 23.686C15.9676 23.686 13.1981 20.9165 13.1981 17.5004C13.1981 14.0843 15.9676 11.3148 19.3837 11.3148C21.1044 11.3148 22.6597 12.0172 23.7812 13.1513C22.4017 11.1611 20.1008 9.85742 17.4956 9.85742C13.274 9.85742 9.85156 13.2798 9.85156 17.5015C9.85156 21.7231 13.274 25.1455 17.4956 25.1455C20.1008 25.1455 22.4017 23.8418 23.7812 21.8516C22.6597 22.9836 21.1033 23.686 19.3837 23.686Z",
    fill: "url(#paint1_linear_13090_62975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0V9.85648C20.1042 9.85754 22.403 11.1612 23.7825 13.1504C22.661 12.0173 21.1056 11.3139 19.3849 11.3139C18.7278 11.3139 18.0939 11.4171 17.5 11.6077V23.3923C18.095 23.5819 18.7278 23.6861 19.3849 23.6861C21.1056 23.6861 22.661 22.9837 23.7825 21.8496C22.403 23.8388 20.1042 25.1425 17.5 25.1435V35C27.1648 35 35.0005 27.1654 35.0005 17.4995C34.9995 7.83464 27.1648 0 17.5 0ZM21.6701 18.3598L21.6743 21.063L20.0821 18.879L17.5126 19.7182L19.0975 17.529L17.5053 15.3449L20.0778 16.1758L21.6627 13.9865L21.6669 16.6897L24.2395 17.5205L21.6701 18.3598Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13090_62975",
    x1: 17.5042,
    y1: 15.3402,
    x2: 22.9439,
    y2: 19.3231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13090_62975",
    x1: 11.3559,
    y1: 12.9451,
    x2: 23.6337,
    y2: 22.0548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAlgr);
export default __webpack_public_path__ + "static/media/flagALGR.1816fd00afbf05c6b3a534df4535fe65.svg";
export { ForwardRef as ReactComponent };